export const KEYBOARD_SHORTCUTS = {
  viewKeyboardShortcuts: {
    mac: 'meta.shift.h',
    windows: 'control.shift.h',
  },
  viewSettings: {
    mac: 'meta.shift.s',
    windows: 'control.shift.s',
  },
  notificationSettings: {
    mac: 'meta.shift.j',
    windows: 'control.shift.j',
  },
  switchTheme: {
    mac: 'meta.shift.m',
    windows: 'control.shift.m',
  },
  portalSearch: {
    mac: 'meta.shift.k',
    windows: 'control.shift.k',
  },
  toggleSideMenu: {
    mac: 'meta.shift.f',
    windows: 'control.shift.f',
  },
  logout: {
    mac: 'meta.shift.x',
    windows: 'control.shift.x',
  },
  goToTab0: {
    mac: 'meta.shift.,',
    windows: 'control.shift.<',
  },
  goToTab1: {
    mac: 'meta.shift.dot',
    windows: 'control.shift.>',
  },
  goToTab2: {
    mac: 'meta.shift./',
    windows: 'control.shift.?',
  },
  goToTab3: {
    mac: 'meta.shift.;',
    windows: 'control.shift.:',
  },
  goToTab4: {
    mac: 'meta.shift.dot',
    windows: 'control.shift.!',
  },
  goToTab5: {
    mac: 'meta.shift./',
    windows: 'control.shift.@',
  },
  goToTab6: {
    mac: 'meta.shift.;',
    windows: 'control.shift.#',
  },
};

export const KEYBOARD_SHORTCUTS_LIST = [
  {
    action: 'View Keyboard Shortcuts',
    macKeys: ['Command', 'Shift', 'H'],
    windowsKeys: ['Ctrl', 'Shift', 'H'],
  },
  {
    action: 'View Settings',
    macKeys: ['Command', 'Shift', 'S'],
    windowsKeys: ['Ctrl', 'Shift', 'S'],
  },
  {
    action: 'Notification Settings',
    macKeys: ['Command', 'Shift', 'J'],
    windowsKeys: ['Ctrl', 'Shift', 'J'],
  },
  {
    action: 'Switch Theme',
    macKeys: ['Command', 'Shift', 'M'],
    windowsKeys: ['Ctrl', 'Shift', 'M'],
  },
  {
    action: 'Portal Search',
    macKeys: ['Command', 'Shift', 'K'],
    windowsKeys: ['Ctrl', 'Shift', 'K'],
  },
  {
    action: 'Toggle Side Menu',
    macKeys: ['Command', 'Shift', 'F'],
    windowsKeys: ['Ctrl', 'Shift', 'F'],
  },
  {
    action: 'Go to Tab 0',
    macKeys: ['Command', 'Shift', '<'],
    windowsKeys: ['Ctrl', 'Shift', '<'],
  },
  {
    action: 'Go to Tab 1',
    macKeys: ['Command', 'Shift', '>'],
    windowsKeys: ['Ctrl', 'Shift', '>'],
  },
  {
    action: 'Go to Tab 2',
    macKeys: ['Command', 'Shift', '?'],
    windowsKeys: ['Ctrl', 'Shift', '?'],
  },
  {
    action: 'Go to Tab 3',
    macKeys: ['Command', 'Shift', ':'],
    windowsKeys: ['Ctrl', 'Shift', ':'],
  },
  {
    action: 'Go to Tab 4',
    macKeys: ['Command', 'Shift', '!'],
    windowsKeys: ['Ctrl', 'Shift', '!'],
  },
  {
    action: 'Go to Tab 5',
    macKeys: ['Command', 'Shift', '@'],
    windowsKeys: ['Ctrl', 'Shift', '@'],
  },
  {
    action: 'Go to Tab 6',
    macKeys: ['Command', 'Shift', '#'],
    windowsKeys: ['Ctrl', 'Shift', '#'],
  },
  {
    action: 'Logout',
    macKeys: ['Command', 'Shift', 'X'],
    windowsKeys: ['Ctrl', 'Shift', 'X'],
  },
];
